import theme from '@corabank/design-tokens/build/tokens/colors.json'
import { Invoice, Person, ReadyToShip } from '@corabank/icons'

export const UPLOAD_TEXTS = {
  BUTTON_LABEL: (docs) => `Enviar documento${docs?.length > 1 ? 's' : ''}`,
  BUTTON_METRIC:
    'up_documento: clicou botao_adicionar_documento [tela_up_documentos]',
  GENERIC_ERROR_METRIC:
    'up_documento: viu_erro altera_doc_nao_enviado [tela_up_documentos]',
  PAGE_TEXT: (
    <>
      Se atente às dicas para o envio correto dos documentos. Aceitamos arquivos
      com até <strong>30MB</strong> nos formatos png, jpeg e pdf.
    </>
  ),
  PAGE_VIEW_METRIC: 'up_documento: viu [tela_up_documentos]',
  REQUIREMENTS: [
    {
      ID: 'ITEM_1',
      ICON: <ReadyToShip color={theme.mainSecondaryDark} />,
      LABEL: 'Deve estar atualizado, completo, com selo e código legível.',
    },
    {
      ID: 'ITEM_2',
      ICON: <Person color={theme.mainSecondaryDark} />,
      LABEL: 'Demonstrar que você tem poderes para abrir e movimentar a conta.',
    },
    {
      ID: 'ITEM_3',
      ICON: <Invoice color={theme.mainSecondaryDark} />,
      LABEL: 'Estar autenticado em cartório ou registrado na Junta Comercial.',
    },
  ],
}
